import { RefinementCtx } from 'zod';

export const notValidEmailErrorMessage = 'error.notValidEmail';

export const addNoMatchingEmailIssue = (ctx: RefinementCtx, path: string[]) => {
  ctx.addIssue({
    code: 'custom',
    message: 'error.noMatchingEmail',
    path,
  });
};
